import { render, staticRenderFns } from "./AverageCompletionTimes.vue?vue&type=template&id=861ff696&"
import script from "./AverageCompletionTimes.vue?vue&type=script&lang=js&"
export * from "./AverageCompletionTimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('861ff696')) {
      api.createRecord('861ff696', component.options)
    } else {
      api.reload('861ff696', component.options)
    }
    module.hot.accept("./AverageCompletionTimes.vue?vue&type=template&id=861ff696&", function () {
      api.rerender('861ff696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/AverageCompletionTimes.vue"
export default component.exports